/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index template to autogenerate all the components and extensions
 * Used by "prepareTemplates"
 */

// import all the available components
import Forms from './forms/Forms'
import PaymentCard from './payment-card/PaymentCard'
import VippsWalletButton from './vipps-wallet-button/VippsWalletButton'

// define / export all the available components
export { Forms, PaymentCard, VippsWalletButton }
